import { PropsWithChildren } from 'react'

import { InvoicesRepository } from '@/Invoices/domain'
import { IUseInvoices, useInvoices } from '@/Invoices/ui/hooks'
import { createGenericContext } from '@/Shared/ui/createGenericContext'

type Context = {
  repository: InvoicesRepository
} & IUseInvoices

type Props = PropsWithChildren & {
  repository: InvoicesRepository
  itemsPerPage?: number
}

const [useInvoice, StateContextProvider] = createGenericContext<Context>()

const InvoiceProvider = ({
  repository,
  itemsPerPage = 8,
  children,
}: Props): JSX.Element => {
  const controller = useInvoices(repository, itemsPerPage)
  return (
    <StateContextProvider value={{ repository, ...controller }}>
      {children}
    </StateContextProvider>
  )
}

export { InvoiceProvider, useInvoice }
